import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalOffer() {
  return <section className="bg-brand-black text-white py-16 px-4 sm:px-6 border-t-8 border-brand-red" data-id="element-116">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-117">
        <div className="space-y-4" data-id="element-118">
          <span className="text-6xl block mb-4 animate-pulse" data-id="element-119">⚠️</span>
          <h2 className="font-archivo text-4xl sm:text-5xl md:text-6xl uppercase text-brand-yellow" data-id="element-120">
            ESTA OFERTA ES POR TIEMPO LIMITADO
          </h2>
        </div>

        <div className="bg-white/10 p-8 rounded-3xl border border-white/20 max-w-xl mx-auto text-left" data-id="element-121">
          <p className="text-2xl font-bold mb-6 text-center" data-id="element-122">Hoy te llevás:</p>
          <ul className="space-y-4 text-lg sm:text-xl font-medium" data-id="element-123">
            <li className="flex items-start gap-3" data-id="element-124">
              <span className="text-brand-green text-2xl" data-id="element-125">✔</span> Kit “Crecer
              Jugando” completo
            </li>
            <li className="flex items-start gap-3" data-id="element-126">
              <span className="text-brand-green text-2xl" data-id="element-127">✔</span> +100
              actividades listas para usar
            </li>
            <li className="flex items-start gap-3" data-id="element-128">
              <span className="text-brand-green text-2xl" data-id="element-129">✔</span> Los 5 bonus
              exclusivos
            </li>
            <li className="flex items-start gap-3" data-id="element-130">
              <span className="text-brand-green text-2xl" data-id="element-131">✔</span> Acceso
              inmediato
            </li>
            <li className="flex items-start gap-3" data-id="element-132">
              <span className="text-brand-green text-2xl" data-id="element-133">✔</span> Formato PDF
              imprimible
            </li>
          </ul>
        </div>

        <div className="space-y-4 pt-4" data-id="element-134">
          <p className="font-archivo text-3xl uppercase" data-id="element-135">TODO ESTO POR SOLO:</p>
          <div className="text-3xl text-gray-400 line-through font-bold" data-id="element-136">
            $49.990
          </div>
          <div className="text-6xl sm:text-7xl font-archivo text-brand-red bg-white inline-block px-8 py-4 rounded-2xl shadow-2xl transform scale-105" data-id="element-137">
            👉 HOY $16.990 ARS
          </div>
        </div>

        <div className="pt-8 space-y-6" data-id="element-138">
          <CTAButton text="🌱 QUIERO AYUDAR A MI HIJO A CRECER JUGANDO" color="green" data-id="element-139" />
          <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-sm sm:text-base font-semibold text-gray-300" data-id="element-140">
            <span data-id="element-141">📩 Descarga inmediata</span>
            <span className="hidden sm:inline" data-id="element-142">•</span>
            <span data-id="element-143">💻 Compatible con cualquier dispositivo</span>
            <span className="hidden sm:inline" data-id="element-144">•</span>
            <span data-id="element-145">🖨️ Imprimible y reutilizable</span>
          </div>
        </div>
      </div>
    </section>;
}